import { useState, useEffect } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { ListBillingPanelsAction } from '@/application/actions';
import { PanelFacturacion } from '@/domain/entities/PanelFacturacion';

export const useBillingPanels = () => {
  const [panels, setPanels] = useState<PanelFacturacion[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const loadPanels = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<ListBillingPanelsAction>(TYPES.ListBillingPanelsAction);
      const result = await action.execute();
      setPanels(result);
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to load billing panels');
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadPanels();
  }, []);

  return { panels, isLoading, error, refetch: loadPanels };
};
